(function() {

    let WORKING_CONDITION = 'WORKING';
    let DAMAGED_CONDITION = 'DAMAGED';
    let RECYCLE_CONDITION = 'RECYCLE';
    let DEFAULT_SUBMIT_TEXT = 'SELL MY DEVICE';
    let RECYCLE_SUBMIT_TEXT = 'RECYCLE MY DEVICE';

    let CONDITION_INFORMATION = {
        'WORKING': {
            title: 'Working Condition',
            content: `<p>Everything works as it should</p>
                <ul class='list-disc'>
                    <li>
                        There is no major damage to the device's case front or rear (light wear and minor scratches are
                        acceptable).
                    </li>
                    <li>There is no damage to the screen.</li>
                    <li>The screen is not showing any signs of screen burn, discolouration or image retention.</li>
                    <li>All the functional buttons e.g. volume and home button are working as expected.</li>
                    <li>The camera, microphone and speakers are all working and free from damage.</li>
                    <li>Includes the battery, and charges up.</li>
                    <li>Has no liquid damage, and has all its internal parts.</li>
                    <li>
                        If the device is bent, broken into pieces or any of the internal parts are showing, it is
                        classed as 'Beyond Economical Repair' or BER. A device that is BER has ZERO value and cannot be
                        traded in.
                    </li>
                </ul>`,
        },
        'DAMAGED': {
            title: 'Damaged/Non-Working Condition',
            content: `<p>There is a problem with your device or it does not work.</p>
                <ul class='list-disc'>
                    <li>There is damage to the device's case front or rear.</li>
                    <li>There is damage to the screen.</li>
                    <li>The screen is showing signs of screen burn, discolouration or image retention.</li>
                    <li>The functional buttons e.g. volume or home button are not working as intended.</li>
                    <li>The camera, microphone or speakers are not working or are damaged.</li>
                    <li>Has a defective battery or does not charge up.</li>
                    <li>Has liquid damage.</li>
                </ul>
                <h4>Exclusions</h4>
                <p>
                    If the device is bent, broken into pieces or any of the internal parts are showing, it is classed as
                    'Beyond Economical Repair' or BER. A device that is BER has ZERO value and cannot be traded in.
                </p>
                <p>
                    <strong>
                        Please note &mdash; if you wish to take advantage of a trade in promotion whilst purchasing a
                        new device and choose to trade in your old device, recyclable devices or devices with ZERO value
                        do not qualify towards any promotion and no additional value will be paid.
                    </strong>
                </p>`,
        },
        'RECYCLE': {
            title: 'I want to recycle',
            content: `<p>As a responsible electrical retailer, we collect, re-use and recycle over 65,000 tonnes of
                waste electronics each year.</p>
                <p>
                    If you want to recycle your device, we will send you a pre-paid envelope to return your device to
                    us. Once received, we will recycle the device and between us we will do our bit for the environment.
                </p>
                <p>
                    <strong>
                        Please note &mdash; if you wish to take advantage of a trade in promotion whilst purchasing a
                        new device and choose to trade in your old device, recyclable devices or devices with ZERO value
                        DO NOT qualify towards any promotion and no additional value will be paid.
                    </strong>
                </p>`,
        },
        'RECYCLE-ONLY': {
            title: 'Unfortunately this device has no reuse value',
            content: 'You can do your bit for the environment and recycle your device through us',
        }
    };

    let state = {
        condition: '',
        offerName: '',
        network: {
            selected: '',
            visible: false,
        },
        offerPrice: {
            value: 0.00,
            visible: false,
        },
    };

    let elem = {
        conditionButton: '[data-condition-key]',
        conditionInformationBox: '[data-condition-information]',
        conditionInfoTitle: '[data-condition-info-title]',
        conditionInfoContent: '[data-condition-info-content]',
        networkListJson: '[data-networks-list-json]',
        networkList: '[data-networks-list]',
        networkListBox: '[data-networks-list-box]',
        offerPriceBox: '[data-offer-price-box]',
        offerPrice: '[data-offer-price]',
        submitButton: '[data-submit]',
        inBasketOfferField: 'input[name="itemData[offer]"]'
    };

    function addNetworkButtons() {
        let networkJson = $(elem.networkListJson).first().text();
        let networks = JSON.parse(networkJson);
        let networksHtml = '<div class="btn-toolbar" data-toggle="buttons">\n';

        $.each(networks, function(key, value) {
            let activeNetwork = (state.network.selected === value.network) ? ' active' : '';
            networksHtml += `<button class="btn btn-default ${activeNetwork}" data-network-key="${key}"
                data-network-name="${value.network}" data-network-price="${value.price}">
                <img src="https://media.secure-mobiles.com/network-logos/${key.toLowerCase()}.png" alt="${key}" width="40"/>
                </button>\n`;
        });

        networksHtml += '</div>\n';
        $(elem.networkList).html(networksHtml);
    }

    function setState(data) {
        $.each(data, function(key, value) {
            state[key] = value;
        });
    }

    function updateConditionActiveButtons() {
        document.querySelectorAll(elem.conditionButton).forEach((el) => {
            const isActive = el.dataset['condition-key'] === state.condition;
            el.classList.toggle('active', isActive);
        });
    }

    function renderView() {
        let conditionState = state.condition;
        let workingDisabled = $('[data-condition-key="' + WORKING_CONDITION + '"]').attr('disabled');
        let damagedDisabled = $('[data-condition-key="' + DAMAGED_CONDITION + '"]').attr('disabled');
        let conditionInfoKey = (workingDisabled === 'disabled' && damagedDisabled === 'disabled') ? 'RECYCLE-ONLY' : conditionState;
        let submitText = (conditionState === RECYCLE_CONDITION) ? RECYCLE_SUBMIT_TEXT : DEFAULT_SUBMIT_TEXT;
        let submitURL = $(elem.submitButton).data('confirmation-path') + '/' + state.offerName;
        const hasNetworks = !!$(elem.networkListJson).text();

        $(elem.inBasketOfferField).val(state.offerName);

        updateConditionActiveButtons();

        if (state.network.visible === true) {
            addNetworkButtons();
            $(elem.networkListBox).show();
        } else {
            $(elem.networkList).text('');
            $(elem.networkListBox).hide();
        }

        if (conditionInfoKey !== '') {
            $(elem.conditionInformationBox).show();
            $(elem.conditionInfoTitle).show();
            $(elem.conditionInfoContent).show();
            $(elem.conditionInfoTitle).html(CONDITION_INFORMATION[conditionInfoKey].title);
            $(elem.conditionInfoContent).html(CONDITION_INFORMATION[conditionInfoKey].content);
        } else {
            $(elem.conditionInformationBox).hide();
            $(elem.conditionInfoTitle).hide();
            $(elem.conditionInfoContent).hide();
            $(elem.conditionInfoTitle).html('');
            $(elem.conditionInfoContent).html('');
        }

        $(elem.offerPrice).text(state.offerPrice.value.toFixed(2));
        $(elem.submitButton).text(submitText);
        $(elem.submitButton).attr('href', submitURL);

        if (state.condition === '') {
            $(elem.submitButton).attr('disabled', 'disabled');
        } else if (state.condition === WORKING_CONDITION && state.network.selected === '' && hasNetworks) {
            $(elem.submitButton).attr('disabled', 'disabled');
        } else {
            $(elem.submitButton).removeAttr('disabled');
        }

        if (state.offerPrice.visible === true) {
            $(elem.offerPriceBox).show();
        } else {
            $(elem.offerPriceBox).hide();
        }
    }

    function networkButtonOnClick() {
        setState({
            condition: WORKING_CONDITION,
            offerName: $(this).data('network-key'),
            network: {
                selected: $(this).data('network-name'),
                visible: true,
            },
            offerPrice: {
                value: $(this).data('network-price'),
                visible: true,
            }
        });

        renderView();
    }

    $(document).on('click', elem.conditionButton, function() {
        let condition = $(this).data('condition-key');

        setState({
            condition: condition,
            offerName: $(this).data('condition-offer-name')
        });
        if ($(this).data('condition-key') == 'RECYCLE' || $(this).data('condition-key') === 'WORKING') {
            $('.button-default[data-condition-key="WORKING"], .button-default[data-condition-key="RECYCLE"]').attr('aria-checked', false);
            $(this).attr('aria-checked', true);
        }

        if (condition === WORKING_CONDITION && $(elem.networkListJson).text() !== '') {
            setState({
                network: {
                    selected: '',
                    visible: true,
                },
                offerPrice: {
                    value: $(this).data('condition-price'),
                    visible: false,
                }
            });
        } else {
            setState({
                network: {
                    selected: '',
                    visible: false,
                },
                offerPrice: {
                    value: $(this).data('condition-price'),
                    visible: true,
                }
            });
        }

        renderView();
    });

    if (document.querySelector('[data-trade-in-basket-launch]')) {
        window.addEventListener('basket:trade-in:product-loaded', function() {
            renderView();
        });
    }

    function initSeeThePrice() {
        $(document).on('click', '[data-network-key]', networkButtonOnClick);
        renderView();
    }

    initSeeThePrice();
})($);
